import type React from 'react';
import { loginUrl } from '@zg-rentals/auth-comet';
import { RentReportingAuthBoundary } from '../contexts/RentReportingAuthProvider';
import { EnrollmentRedirectHandler } from './EnrollmentRedirectHandler';
import { ClickstreamAuthTriggerSource, emitAuthStartEvent } from '../analytics/events';

interface RentReportingBoundaryProps {
  children: React.ReactNode;
  requireAuth?: boolean;
}

export const RentReportingBoundary: React.FC<RentReportingBoundaryProps> = ({ children, requireAuth = false }) => {
  if (!requireAuth) {
    return <EnrollmentRedirectHandler>{children}</EnrollmentRedirectHandler>;
  }

  const isDevelopment = process.env.NODE_ENV === 'development';
  const host = isDevelopment ? 'https://www.qa.zillow.net' : '';

  return (
    <RentReportingAuthBoundary
      redirectHref={(currentUrl) => {
        const url = new URL(currentUrl);
        const triggerSource = ClickstreamAuthTriggerSource.ESUSU_DASHBOARD;

        url.searchParams.set('auth_trigger', triggerSource);
        const redirectUrl = `${url.pathname}${url.search}`;

        emitAuthStartEvent(triggerSource);
        return loginUrl({
          host,
          redirectUrl,
          crossEnv: isDevelopment,
          protocol: 'https',
          port: isDevelopment ? 3000 : undefined,
        });
      }}
    >
      <EnrollmentRedirectHandler>{children}</EnrollmentRedirectHandler>
    </RentReportingAuthBoundary>
  );
};
